// this is used as a key for the form values for consistency
const OBJECTIVE_FORM_KEYS = {
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  competency: 'competency',
  language: 'language',
  cognitiveVerbs: 'cognitiveVerbs',
  affectiveVerbs: 'affectiveVerbs',
  psychomotorVerbs: 'psychomotorVerbs',

  // affective fields
  affectiveValuesVerbs: 'affectiveValuesVerbs',
  affectiveValuesVerbs2: 'affectiveValuesVerbs2',
  affectiveValuesVerbs3: 'affectiveValuesVerbs3',

  affectiveAttitudesVerbs: 'affectiveAttitudesVerbs',
  affectiveAttitudesVerbs2: 'affectiveAttitudesVerbs2',
  affectiveAttitudesVerbs3: 'affectiveAttitudesVerbs3',

  valuesList: 'valuesList',
  valuesList2: 'valuesList2',
  valuesList3: 'valuesList3',

  attitudesList: 'attitudesList',
  attitudesList2: 'attitudesList2',
  attitudesList3: 'attitudesList3',
  // for american objective
  curriculumFramework: 'curriculumFramework',
  specificStandards: 'specificStandards',

  //benchmark
  objectives: 'objectives',
};

export default OBJECTIVE_FORM_KEYS;
